module.exports = __webpack_public_path__ + "static/media/student_show.a6a9730c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/student_show.jpg
// module id = 1276
// module chunks = 0